import { CustomImage } from '@/components/CustomImage';
import { useMissionStore } from '../../../shared/store/useMissionStore';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { useMissionDetailingStore } from '../../store/useMissionDetailingStore';
import { arrowMissionImg } from '@/components/Card/Mission';
import { useMemo } from 'react';

export const MissionHero = () => {
  const mission = useMissionStore((state) => state.mission);
  const missionPage = useMissionDetailingStore((state) => state.missionPage);

  const programmes = useMemo(
    () => mission?.programmes?.map((programme) => programme?.name).join(', '),
    [mission?.programmes],
  );

  if (!mission || !missionPage) {
    return null;
  }

  const imageSrc = mission.cover.url;

  return (
    <>
      <div className="relative">
        <div className="h-full max-h-[477px] w-full max-w-[849px] overflow-hidden rounded-2xl">
          <CustomImage
            src={imageSrc}
            alt={missionPage.pageTitle}
            className="!h-full !max-h-[477px] !w-full !max-w-[849px] object-cover"
          />
        </div>
        <img
          src={arrowMissionImg}
          alt="arrow content type"
          className="-bottom-5.5 absolute right-10 -translate-y-1/2"
        />
      </div>
      <div className="mt-sh-60">
        <h1 className="font-cadiz text-base font-bold">{programmes}</h1>
        <h2 className="mt-1 font-cadiz text-sh-28-32 font-bold">{mission.roleModel}</h2>
        <div className=" my-2 flex flex-row gap-2">
          <DefaultContentTemplateTags
            type="MISSION"
            tags={[mission.keyStage?.keyStage ?? '']}
            uppercase
            className="!my-3"
          />
          <DefaultContentTemplateTags type="MISSION" tags={[mission.trait?.trait ?? '']} className="!my-3" />
        </div>
      </div>
    </>
  );
};
